module.exports = {
  assert: function(condition, message) {
    if (message == null) {
      message = 'Failed Assert';
    }
    if (!condition) {
      throw new Error(message);
    }
  },
  repeat: function(pattern, count) {
    var result;
    if (count <= 0) {
      return '';
    } else {
      result = '';
      while (count > 1) {
        if (count & 1) {
          result += pattern;
        }
        count >>= 1;
        pattern += pattern;
      }
      return result + pattern;
    }
  },
  shallowArrayEqual: function(a, b) {
    var i, index, len, value;
    if (!a && !b) {
      return true;
    }
    if (!a && b || a && !b) {
      return false;
    }
    if (a.length !== b.length) {
      return false;
    }
    for (index = i = 0, len = a.length; i < len; index = ++i) {
      value = a[index];
      if (b[index] !== value) {
        return false;
      }
    }
    return true;
  },
  shallowObjectEqual: function(a, b) {
    var i, j, key, len, len1, numKeysA, numKeysB, ref;
    if (!a && !b) {
      return true;
    }
    if (!a && b || a && !b) {
      return false;
    }
    numKeysA = 0;
    numKeysB = 0;
    ref = Object.keys(b);
    for (i = 0, len = ref.length; i < len; i++) {
      key = ref[i];
      numKeysB++;
      if (!a[key] !== b[key]) {
        return false;
      }
    }
    for (j = 0, len1 = a.length; j < len1; j++) {
      key = a[j];
      numKeysA++;
    }
    return numKeysA === numKeysB;
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/util.js
 ** module id = 9
 ** module chunks = 0
 **/